import React from "react";
import innovative from "./../../../images/innovative.png"
import responsive from "./../../../images/responsive.png"
import quality_deliverables from './../../../images/quality_deliverables.png'

import gray_dots from './../../../images/gray_dots.jpg'



const SecondPane = () => (
      <div className=""
      
      
      style={{ backgroundImage: `url(${gray_dots})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      paddingBottom: '50px',
      height: '20vh',
     
  }}
      
      
      >
    <div className="uk-container ">
             <div className="introContainer uk-container ">
                  
                <div className="uk-grid uk-grid-collapse" data-uk-grid>
                      <div className="uk-width-1-3@s uk-padding ">
                            <div className="uk-grid uk-grid-collapse" data-uk-grid>
                                  <div className="uk-width-1-5 " uk-scrollspy="cls: uk-animation-slide-left; repeat: true">
                                   <img src = {innovative} />
                                  </div>
                                  <div className="uk-width-4-5" uk-scrollspy="cls: uk-animation-slide-right; repeat: true">
                                  <p className="uk-margin-left uk-text-bold">Innovative</p>
                                  <p className="uk-margin-left blurbText">Spotlight on research + innovation, pursuing 
                                  new solutions for sustainability.</p>
                                  </div>

                            </div>
                      </div>

                      <div className="uk-width-1-3@s uk-padding">
                      <div className="uk-grid uk-grid-collapse" data-uk-grid>
                                  <div className="uk-width-1-5 " uk-scrollspy="cls: uk-animation-slide-left; repeat: true">
                                   <img src = {responsive} />
                                  </div>
                                  <div className="uk-width-4-5" uk-scrollspy="cls: uk-animation-slide-right; repeat: true">
                                  <p className="uk-margin-left uk-text-bold">Responsive</p>
                                  <p className="uk-margin-left blurbText">We are prompt and find creative, efficient, and durable solutions  for projects</p>
                                  </div>

                            </div>
                      </div>

                      <div className="uk-width-1-3@s uk-padding">
                      <div className="uk-grid uk-grid-collapse" data-uk-grid>
                                  <div className="uk-width-1-5 " uk-scrollspy="cls: uk-animation-slide-left; repeat: true">
                                   <img src = {quality_deliverables} />
                                  </div>
                                  <div className="uk-width-4-5" uk-scrollspy="cls: uk-animation-slide-right; repeat: true">
                                  <p className="uk-margin-left uk-text-bold">Quality Deliverables</p>
                                  <p className="uk-margin-left blurbText"> Through our collaborative, interdisciplinary 
                                  approach, we don't compromise quality.</p>
                                  </div>

                            </div>
                      </div>
                </div>
             

             </div>

</div>
</div>
);



export default SecondPane;